module.exports = __webpack_public_path__ + "static/katahira_camp_01-81a2dba34fde6bad3cc5df7de4877d00.jpg";